import React, { FC } from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

const UppercaseTextField: FC<TextFieldProps> = ({ onChange, ...props }) => {
  const handleUppercaseChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = (e.target.value || '').toUpperCase();
    
    if (onChange) {
      onChange(e);
    }
  };

  return <TextField {...props} onChange={handleUppercaseChange} />;
};

export default UppercaseTextField;